import { SaleDetail, SaleFormValues } from "../../../types/sale";

export const mapCreditNote = (data: SaleDetail): SaleFormValues => ({
  id: data.id,
  correlativeId: data?.correlativeId,
  documentNumber: data.documentNumber,
  saleDate: data.saleDate,
  branch: data.branch,
  customer: data.customer,
  documentType: data.documentType,
  paymentMethod: data.paymentMethod,
  globalDiscountPercentage: data.globalDiscountPercentage || 0,
  globalDiscountTarget: data.globalDiscountTarget || 'PRODUCTS',
  paymentCondition: data.paymentCondition,
  comments: data.comments,
  products: data.creditNoteDetails?.products || [],
  totals: data.creditNoteDetails?.totals || {},
  totalsView: data.creditNoteDetails?.totalsView || {},
  individualPayments: {},

  // ✅ Nuevos campos de referencia
  creditNoteId: data.creditNoteDetails?.creditNoteId,
  creditFiscalId: data.creditNoteDetails?.creditFiscalId,
});
